var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_240_8298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.92893 20.2132C1.02369 16.308 1.02372 9.97628 4.92893 6.07107C8.83418 2.16582 15.1658 2.16582 19.0711 6.07107C22.9763 9.97628 22.9763 16.308 19.0711 20.2132C15.1659 24.1184 8.83414 24.1184 4.92893 20.2132ZM6.34315 18.799C9.46736 21.9232 14.5326 21.9232 17.6569 18.799C20.781 15.6748 20.7811 10.6095 17.6569 7.48528C14.5327 4.36109 9.46734 4.36109 6.34315 7.48528C3.21894 10.6095 3.21895 15.6748 6.34315 18.799ZM13 12.1421L17 12.1421L17 14.1421L13 14.1421V18.1421H11V14.1421L7.00003 14.1421L7.00002 12.1421L11 12.1421L11 8.14213H13L13 12.1421Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_240_8298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.77002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleIcon);
export default __webpack_public_path__ + "static/media/addCircleIcon.a43cdd0e.svg";
export { ForwardRef as ReactComponent };